import { render, staticRenderFns } from "./WorstInsight.vue?vue&type=template&id=7a7c8931&scoped=true&"
import script from "./WorstInsight.vue?vue&type=script&lang=js&"
export * from "./WorstInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c8931",
  null
  
)

export default component.exports